import React, { Component } from "react";

export class RadioInput extends Component {
  render() {
    const {
      label,
      id,
      name,
      svg,
      viewBox,
      value,
      onChange,
      subLabel,
      checked,
    } = this.props;

    return (
      <div className="ob-input">
        <div className="ob-input__radio-container">
          <input
            type="radio"
            value={value}
            id={id}
            name={name}
            className="ob-input__radio-control"
            onChange={onChange}
            checked={checked}
          />
          {label && (
            <label className="ob-input__radio-label" htmlFor={id}>
              <div className="radio-label__text">
                <span className="radio-label__text-main">{label}</span>
                <span className="radio-label__text-sub">{subLabel}</span>
              </div>
              <svg className="radio-label__svg" viewBox={viewBox}>
                <use xlinkHref={svg}></use>
              </svg>
            </label>
          )}
        </div>
      </div>
    );
  }
}

export default RadioInput;
